import { render, staticRenderFns } from "./OrderCreatorServiceGlobal.vue?vue&type=template&id=da28f8d6&scoped=true&"
import script from "./OrderCreatorServiceGlobal.vue?vue&type=script&lang=js&"
export * from "./OrderCreatorServiceGlobal.vue?vue&type=script&lang=js&"
import style0 from "./OrderCreatorServiceGlobal.vue?vue&type=style&index=0&id=da28f8d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da28f8d6",
  null
  
)

export default component.exports